/*
Item: Form to Editing Standard Folders
Name: StandardFolder
Format: Frontend component, partial screen
*/

import React, { Component } from 'react';
import { Growl } from 'primereact/growl';

import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import JsonHelper, {
  CategoryEnums, StatisticsNames, StatisticNumbersFolders, TypeNames,
} from '../utils/statisticsUtils';
import MessageService from '../service/MessageService';
import NodeService from '../service/NodeService';
import StandardFoldersDialog from '../components/dialogue/StandardFoldersDialog';
import StandardFoldersEditDialog from '../components/dialogue/StandardFoldersEditDialog';
import TreeTableWrapper from '../components/TreeTableWrapper';

const DialogType = Object.freeze({
  none: 0,
  delete: 1,
  rename: 2,
  newFolder: 3,
  switchLoc: 4,
});

export default class StandardFolders extends Component {
  constructor() {
    super();
    this.state = {
      nodes: [], // todo what is this?

      // tag if filterDialog is visible
      filterDialogVisible: false,
      // type of current editDialog
      currentDialogType: DialogType.none,
      // currentSelectedNode in TreeTable
      currentNode: undefined,
      // new Name for renameing or creating node
      newNodeDataName: undefined,
      // allNodes
      allNodes: [],
      // key of the node which is selected as new father node in the edit dialog
      selectedTreeNodeKey: undefined,
      // state for wait spinner dialog
      visibleWait: true,

    };

    this.messageService = new MessageService();
    this.nodeservice = new NodeService();
    this.actionTemplate = this.actionTemplate.bind(this);
    this.confirmEditDialog = this.confirmEditDialog.bind(this);
    this.onHideFilterDialog = this.onHideFilterDialog.bind(this);
    this.onHideEditDialog = this.onHideEditDialog.bind(this);
    this.handleYesFilterDialog = this.handleYesFilterDialog.bind(this);
    this.setNewNodeDataName = this.setNewNodeDataName.bind(this);
    this.setSelectedTreeNodeKey = this.setSelectedTreeNodeKey.bind(this);
    this.createBackEnd = this.createBackEnd.bind(this);
    this.saveBackEnd = this.saveBackEnd.bind(this);

    this.myTreeTable = React.createRef();
  }

  componentDidMount = async () => {
    const right = 'ALL';
    await this.nodeservice.getTreeTableNodes('assets/treetablenodesall.json').then((data) => this.setState({ allNodes: data }));
    const { allNodes } = this.state;
    try {
      const type = 'ordercriterion';
      const objectTyp = 'ORDERCRITERION';
      const objectNumber = '109'; // STRUCTURE=108
      const prefix = '0';
      const children2 = await this.getDirectory(type, right, objectNumber, objectTyp, prefix);

      // über alle in children
      for (let i = 0; i < children2.length; i += 1) {
        const { name } = children2[i].data;
        const { id } = children2[i].data;
        const statistic = StatisticNumbersFolders[children2[i].data.statisticName];
        const category = CategoryEnums[children2[i].data.topicType];
        const subCategory = allNodes[statistic].children[category].children.length;
        const insertItem = {
          key: '0-0-2',
          data: {
            name: 'NeuerOrdner', id: 8, statistic: 0, category: 0,
          },
          category: 'Standardtabelle',
          selectable: true,
        };
        const key = `${statistic}-${category}-${subCategory}`;
        insertItem.key = key;
        insertItem.data.name = name;
        insertItem.data.id = id;
        insertItem.data.statistic = statistic;
        insertItem.data.category = category;
        allNodes[statistic].children[category].children[subCategory] = insertItem;
      }
      this.setState({ allNodes });
    } catch (e) {
      console.error('ERROR in componentDidMount', e);
    } finally {
      this.setState({ visibleWait: false });
    }
  }

  async getDirectory(type, right, objectNumber, objectTyp, prefix) {
    const typeString = 'Standard';
    const elementsData1 = await this.messageService.postVariableDirectory('directory', type, right, objectNumber, objectTyp, typeString);
    let children = [];
    if (elementsData1[0]) {
      this.growl.show({ severity: elementsData1[1], summary: `Hinweis zu ${TypeNames[type]}`, detail: elementsData1[0] });
    } else {
      const entries = elementsData1.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
      children = entries.map((entry, i) => (
        {
          key: `${prefix}-${i}`,
          type,
          objectNumber,
          data: {
            name: entry.name,
            date: entry.modifiedTime,
            statisticName: entry.statisticName,
            id: entry.id,
            topicType: entry.topicType,
            data: entry,
          },
        }
      ));
    }
    if (elementsData1[2] === -1) {
      window.location.replace(`${process.env.PUBLIC_URL}/login`);
    }
    return children;
  }

  /** ******** methods for MyTreeTable ********************* */
  actionTemplate(node) {
    return (
      <div>
        {node.selectable
          ? (
            <Button
              type="button"
              icon="pi-md-edit"
              title="Umbenennen"
              className="p-button-success"
              onClick={() => this.openEditDialog(node, DialogType.rename)}
            />
          ) : undefined}
        {node.selectable
          ? (
            <Button
              type="button"
              icon="pi-md-redo"
              title="Verschieben"
              className="p-button-success"
              onClick={() => this.openEditDialog(node, DialogType.switchLoc)}
            />
          ) : undefined}
        {node.selectable
          ? (
            <Button
              type="button"
              icon="pi-md-delete"
              title="Löschen"
              className="p-button-danger"
              onClick={() => this.openEditDialog(node, DialogType.delete)}
            />
          ) : undefined}
        {!node.selectable && node.key.length > 1
          ? (
            <Button
              type="button"
              icon="pi-md-create-new-folder"
              title="Neuer Unterordner"
              className="p-button-success"
              onClick={() => this.openEditDialog(node, DialogType.newFolder)}
            />
          ) : undefined}
      </div>
    );
  }

  openEditDialog(node, type) {
    const newState = { currentDialogType: type, currentNode: node };
    if (type === DialogType.rename) {
      newState.newNodeDataName = node.data.name;
    }
    this.setState(newState);
  }

  /** *** methods for edit dialog **** */
  onHideEditDialog() {
    this.setState({
      currentDialogType: DialogType.none,
      currentNode: undefined,
      newNodeDataName: undefined,
      selectedTreeNodeKey: undefined,
    });
  }

  setSelectedTreeNodeKey(newFatherNodeKey) {
    this.setState({ selectedTreeNodeKey: newFatherNodeKey });
  }

  setNewNodeDataName(name) {
    this.setState({ newNodeDataName: name });
  }

  confirmEditDialog() {
    console.log('MOVENODE#start')
    const {
      currentNode, allNodes, newNodeDataName, selectedTreeNodeKey, currentDialogType,
    } = this.state;
    const nodeKey = currentNode.key;
    const allNodesCopy = JSON.parse(JSON.stringify(allNodes));
    const currentNodeEnvironment = this.myTreeTable.current.findNodeEnvironment(
      allNodesCopy,
      nodeKey,
    );
    console.log('MOVENODE#', currentDialogType, allNodesCopy, currentNodeEnvironment);
    // let newNodeObj;
    let node;
    let newNodeEnvironment;
    switch (currentDialogType) {
      case DialogType.delete:
        this.myTreeTable.current.deleteNode(currentNodeEnvironment, true);
        break;
      case DialogType.rename:
        this.myTreeTable.current.renameNode(currentNodeEnvironment);
        break;
      case DialogType.newFolder:
        const newNodeObj = { selectable: true, data: { name: newNodeDataName } };
        this.myTreeTable.current.insertNode(currentNodeEnvironment, newNodeObj, false);
        break;
      case DialogType.switchLoc:
        console.log('MOVENODE#0.0');
        node = currentNodeEnvironment.nodesArray[currentNodeEnvironment.position];
        newNodeEnvironment = this.myTreeTable.current.findNodeEnvironment(
          allNodesCopy,
          selectedTreeNodeKey,
        );
        console.log('MOVENODE#0.1');
        this.myTreeTable.current.moveNode(newNodeEnvironment, node, currentNodeEnvironment);
        console.log('MOVENODE#0.2');
        break;
      default:
    }
    this.setState({ allNodes: allNodesCopy }, () => this.onHideEditDialog());
  }

  /** ******** methods for BackEnd saving ********************* */

  async createBackEnd(node, newNodeDataName, statisticName, topicType) {
    let success;
    const { name } = node.data;
    const ret = await this.messageService.postOrdercriterionInsert(name, statisticName, topicType);
    if (ret[0]) {
      this.growl.show({ severity: ret[1], summary: 'Hinweis', detail: ret[0], life: 8000 });
      success = false;
    } else {
      success = ret;
    }
    return success;
  }

  async confirmYnDialog() {
    const {
      newNodeDataName, tmpNodesArray, tmpNode, tmpCurrentNodeEnvironment, confirmation,
    } = this.state;
    let success = true;
    const { data } = confirmation;
    let ret;
    this.setState({ visibleYn: false, visibleWait: true });
    try {
      ret = await this.messageService.postRecordStructureDelete(data);
    } catch (err) {
      console.log('ERROR in confirmYnDialog', err);
      success = false;
    } finally {
      this.setState({ visibleWait: false });
    }
    // e.g. 5 109 'ordercriterion' false undefined ? delete
    if (ret[0]) {
      success = false;
      const message = ret[0].replace('java.lang.Exception:', '');
      this.growl.show({ severity: ret[1], summary: 'Hinweis', detail: message });
    } else {
      // nothing
    }
    if (success) {
      tmpNodesArray.splice(tmpCurrentNodeEnvironment.position, 1); // gelöschte Zeile entfernen
      tmpNode.data.name = newNodeDataName; // funktioniert nicht hinter dem await!
      // this.updateKeyOfItemAndChildItems(
      this.myTreeTable.current.updateKeyOfItemAndChildItems(
        tmpNodesArray, tmpCurrentNodeEnvironment.position, tmpCurrentNodeEnvironment.depth,
      );
    }
    this.setState({ data }); // don't delete, this triggers a FE update!
  }

  async saveBackEnd(node, newNodeDataName, statisticName, topicType, actionLink, nodesArray, currentNodeEnvironment) {
    let link = actionLink;
    if (!actionLink) link = 'update';
    let success = true;
    // const { nodesArray } = currentNodeEnvironment;
    const { id } = node.data;
    const { objectNumber } = node;
    const type = 'ordercriterion';
    // const { type } = node;
    const elementsData = await this.messageService.postRecordStructureProperties(
      id, objectNumber, type, false,
    );

    if (elementsData[0]) {
      this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: elementsData[0] });
      success = false;
    } else {
      const insertMessage = JsonHelper.deepCopy(elementsData);
      if (newNodeDataName) {
        insertMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].name = newNodeDataName;
      }
      if (statisticName) {
        insertMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].statisticName = statisticName;
      }
      if (topicType) {
        insertMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].topicType = topicType;
      }
      const ret = await this.messageService.postRecordStructureProperties(
        id, objectNumber, type, false, undefined, insertMessage, link,
      );
      if (ret[0]) {
        if (ret[3] === 18129) {
          success = false;
          const message = ret[0];
          const confirmation = ret[2];
          // anzeigen Dialog
          this.setState({
            visibleYn: true,
            message,
            tmpNodesArray: nodesArray,
            tmpNode: node,
            tmpCurrentNodeEnvironment: currentNodeEnvironment,
            confirmation,
          });
          // nodesArray.splice(currentNodeEnvironment.position, 1); // gelöschte Zeile im FE entfernen
          //node.data.name = newNodeDataName; // funktioniert nicht hinter dem await!
          //this.updateKeyOfItemAndChildItems(
          //  nodesArray, currentNodeEnvironment.position, currentNodeEnvironment.depth,
          //);
        } else {
          const message = ret[0].replace('java.lang.Exception:', '');
          this.growl.show({ severity: ret[1], summary: 'Hinweis', detail: message, life: 5000 });
          success = false;
        }
      }
    }
    return success;
  }

  /** ******** methods for Filter Dialog ********************* */
  linkClick(address) {
    this.props.history.push(`./${address}`);
  }

  onHideFilterDialog() {
    this.setState({ filterDialogVisible: false });
  }

  handleYesFilterDialog() {
    this.setState({ filterDialogVisible: false });
  }

  renderYnFooter() {
    const { onHide, confirmDialog } = this.props;
    return (
      <div>
        <Button
          id="yes"
          label="Ja"
          icon="pi pi-check"
          onClick={() => this.confirmYnDialog()}
        />
        <Button
          id="no"
          label="Nein"
          className="p-button-danger"
          icon="pi pi-times"
          onClick={() => this.setState({ visibleYn: false })}
        />
      </div>
    );
  }

  /** ******** render methods ********************* */
  render() {
    const statistic = window.location.href.split('&')[1];
    const {
      currentNode,
      selectedCategory,
      filterDialogVisible,
      currentDialogType,
      visibleWait,
      allNodes,
      selectedNodeKey1,
      selectedTreeNodeKey,
      nodes,
      newNodeDataName,
      visibleYn,
      message,
    } = this.state;
    return (
      <div className="p-col-12 p-lg-12">
        <StandardFoldersDialog
          onHide={this.onHideFilterDialog}
          selectedCategory={selectedCategory}
          visible={filterDialogVisible}
          handleYes={this.handleYesFilterDialog}
        />
        <Dialog header="Lade Daten..." closable={false} closeOnEscape={false} visible={visibleWait} modal onHide={() => this.setState({ visibleWait: false })}>
          <div style={{ textAlign: 'center' }}><ProgressSpinner /></div>
        </Dialog>
        <Dialog
          header="Löschen"
          closeOnEscape={false}
          visible={visibleYn}
          modal
          onHide={() => this.setState({ visibleYn: false })}
          footer={this.renderYnFooter()}
        >
          <div><p><h3>{message}</h3></p></div>
        </Dialog>
        <StandardFoldersEditDialog
          onHide={this.onHideEditDialog}
          currentDialogType={currentDialogType}
          confirmDialog={this.confirmEditDialog}
          selectedTreeNodeKey={selectedTreeNodeKey}
          setSelectedTreeNodeKey={this.setSelectedTreeNodeKey}
          newNodeDataName={newNodeDataName}
          setNewNodeDataName={this.setNewNodeDataName}
          currentNode={currentNode}
          nodes={nodes}
          allNodes={allNodes}
        />
        <Growl ref={(el) => this.growl = el} />
        <h2>{StatisticsNames[statistic]}</h2>
        <div className="p-grid dashboard">
          <div className="p-col-12 p-md-12">
            <TreeTableWrapper
              ref={this.myTreeTable}
              currentNode={currentNode}
              allNodes={allNodes}
              nodes={nodes}
              saveBackEnd={this.saveBackEnd}
              createBackEnd={this.createBackEnd}
              selectedNodeKey1={selectedNodeKey1}
              newNodeDataName={newNodeDataName}
              // onSelectionChange={this.onSelectionChange}
            >
              <Column field="name" header="Ordnerverzeichnis" expander />
              <Column body={this.actionTemplate} style={{ textAlign: 'right', width: '10rem' }} />
            </TreeTableWrapper>
          </div>
        </div>
      </div>
    );
  }
}
